export default __webpack_public_path__ + "static/media/ts_bi_c.d3b82fab.svg";